//API_IMPORT_START ====
import { query_log_record_list } from '@/api/log_app-model';
//API_IMPORT_END
import { SearchConfig, Record } from '@/components/page-model/typing';
import ls from '@/utils/local-storage';
import { STORAGE_CURRENT_ORG_KEY } from '@/store/mutation-type';
import { btn_list, head_btn_list, event_obj } from './log_app-logrecordinfo-config';
import column_config from './log_app-logrecordinfo-column-config';

import { reactive } from 'vue';
import moment from 'moment';

export default () => {
  const None = null;
  const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org
  const { baseColumns } = column_config(current_org);

  const search_config: SearchConfig = {
    settings: {
      labelAlign: 'right',
      layout: 'inline',
    },
    fields: [
      {
        type: 'rangepicker',
        name: 'create_time',
        label: '创建时间',
        disabled: false,
        allowClear: true,
        inputType: 'number',
        defaultValue: '',
        valueFormat: 'YYYY-MM-DD HH:mm',
        showTime: true,
        placeholder: '请填写创建时间',
      },
      {
        type: 'input',
        name: 'message',
        label: '日志简注',
        disabled: false,
        allowClear: true,
        inputType: 'text',
        defaultValue: '',
        placeholder: '请填写日志简注',
      },
      {
        type: 'input',
        name: 'r_id',
        label: '日志ID',
        disabled: false,
        allowClear: true,
        inputType: 'text',
        defaultValue: '',
        placeholder: '请填写日志ID',
      },
    ],
    rules: { create_time: [{ required: true, message: '请填输入创建时间' }] },
    model: reactive({
      org_id: current_org?.id,
      is_active: true,
      create_time: null,
      level: null,
      message: null,
      r_id: null,
    }),
  };
  const search_options = {
    level: [
      { value: None, name: '全部' },
      { value: 2, name: '基础信息' },
      {
        value: 3,
        name: '调试',
      },
      { value: 4, name: '信息' },
      { value: 5, name: '数据成功' },
      { value: 6, name: '数据异常' },
      {
        value: 7,
        name: '逻辑错误',
      },
      { value: 8, name: '程序崩溃' },
    ],
  };

  const titleList = {
    title: '日志详情',
    addModalTitle: '新建log record',
    updateTitle: '修改log record',
    is_create: false, // 是否有【新建】按钮
    is_update: false, // 是否有【修改】按钮
    is_remove: false, // 是否有【删除】按钮
    is_recover: false, // 是否有【恢复】按钮
  };

  const api_fields: Record = {
    update: {
      id: 'id',
    },
    delete: {
      id: 'id',
    },
    recover: {
      id: 'id',
    },
    updateData: {
      org_id: 'org_id',
      id: 'id',
    },
  };

  return {
    searchConfig: search_config,
    searchConfigOptions: search_options,
    formModalConfig: {},
    formModalConfigOptions: {},
    updateFormModalConfig: {},
    updateFormModalConfigOptions: {},
    queryData: query_log_record_list,
    addData: None,
    updateData: None,
    removeData: None,
    recoverData: None,
    baseColumns: baseColumns,
    slotList: null,
    titleList: titleList,
    api_fields: api_fields,
    btn_list: btn_list,
    head_btn_list: head_btn_list,
    event_obj: event_obj,
  };
};
